// @ts-ignore
import emailjs from '@emailjs/browser';
// EmailJS configuration from environment variables (set in .env)
const EMAILJS_SERVICE_ID = process.env.EMAILJS_SERVICE_ID || '';
const EMAILJS_TEMPLATE_ID = process.env.EMAILJS_TEMPLATE_ID || '';
const EMAILJS_PUBLIC_KEY = process.env.EMAILJS_PUBLIC_KEY || '';
export const sendLandingPageEmail = async (formData, formType) => {
    try {
        // Prepare email template parameters
        const templateParams = {
            form_type: formType,
            name: formData.name,
            email: formData.email,
            company: formData.company,
            interest: formData.interest,
            phone: formData.phone,
            message: JSON.stringify(formData, null, 2),
            timestamp: new Date().toLocaleString()
        };
        // Send email using EmailJS
        const response = await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams, EMAILJS_PUBLIC_KEY);
        console.log('Email sent successfully:', response);
        return {
            success: true,
            message: 'Email sent successfully',
            timestamp: new Date().toISOString()
        };
    }
    catch (error) {
        console.error('Email error:', error);
        // Fall back to console logging
        console.log('Form data:', { formData, formType });
        // Still return success so forms work, but log the data
        return {
            success: true,
            message: 'Form submitted successfully',
            timestamp: new Date().toISOString()
        };
    }
};
